var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_302_499)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6089 19.0867C18.5292 19.1651 18.4344 19.2274 18.33 19.2698C18.2255 19.3123 18.1135 19.3342 18.0003 19.3342C17.8872 19.3342 17.7752 19.3123 17.6707 19.2698C17.5663 19.2274 17.4715 19.1651 17.3918 19.0867L13.4663 15.2474C13.3866 15.169 13.2918 15.1068 13.1874 15.0643C13.0829 15.0219 12.9709 15 12.8578 15C12.7446 15 12.6326 15.0219 12.5282 15.0643C12.4237 15.1068 12.3289 15.169 12.2492 15.2474C12.0896 15.4041 12 15.6161 12 15.8371C12 16.0581 12.0896 16.2701 12.2492 16.4268L16.1833 20.2661C16.6654 20.7361 17.3189 21 18.0003 21C18.6817 21 19.3353 20.7361 19.8174 20.2661L23.7514 16.4268C23.9098 16.271 23.999 16.0607 24 15.8413C24.0006 15.7312 23.979 15.6221 23.9364 15.5202C23.8937 15.4183 23.8309 15.3256 23.7514 15.2474C23.6717 15.169 23.577 15.1068 23.4725 15.0643C23.3681 15.0219 23.256 15 23.1429 15C23.0297 15 22.9177 15.0219 22.8133 15.0643C22.7088 15.1068 22.614 15.169 22.5344 15.2474L18.6089 19.0867Z",
    fill: "white",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_499",
    x1: 36,
    y1: -0.00000184591,
    x2: -6.84365,
    y2: 12.4508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A677B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.dcd42a502a594a1f91877cd8a0850e9a.svg";
export { ForwardRef as ReactComponent };